<template>
    <div class="h100 flex-column">
        <div class="flex items-center">
            <div class="flex-width"></div>
            <a-select v-model="searchForm.project_id" style="width: 200px" size="small" placeholder="项目" @change="getLawLetter">
                <a-select-option
                    v-for="item in projects"
                    :key="item.id" 
                    :value="item.id"
                >
                    {{ item.name }}
                </a-select-option>
            </a-select>
            <a-input-search class="ml5" v-model="searchForm.text" addon-before="搜索" placeholder="搜索" style="width: 250px" @search="getLawLetter" size="small" />
            <div class="ml5">
                <a-button type="danger" size="small" @click="showAdd">添加</a-button>
            </div>
        </div>
        <!-- <div class="mt5 flex-height" id="dataview"> -->
        <div class="mt5" id="dataview">
            <a-table :loading="loading" :data-source="data" size="small" bordered :pagination="false" :scroll="{x:2350}">
                <a-table-column key="key" title="序号" fixed="left" :width="80" data-index="key" align="center"/>
                <a-table-column key="project_name" title="项目名称" fixed="left" :width="300" data-index="project_name" align="center" ellipsis=true />
                <a-table-column key="release_time" title="发函时间" :width="150" data-index="release_time" align="center"/>
                <a-table-column key="receive_time" title="收件时间" :width="150" data-index="receive_time" align="center"/>
                <a-table-column key="company_entity" title="我方单位" data-index="company_entity" :width="200" align="center"/>
                <a-table-column key="check_amount" title="核对金额" :width="150" data-index="check_amount" align="center"/>
                <a-table-column key="release_entity" title="发函单位" data-index="release_entity" :width="200" align="center"/>
                <a-table-column key="entity_prop" title="单位属性" :width="150" data-index="entity_prop" align="center"/>
                <a-table-column key="law_firm_name" title="委托律所" :width="200" data-index="law_firm_name" align="center"/>
                <a-table-column key="appeal" title="发函诉求" data-index="appeal" align="center"/>
                <a-table-column key="contact_person" title="联系人" :width="150" data-index="contact_person" align="center"/>
                <a-table-column key="contact_person_phone" title="联系电话" :width="150" data-index="contact_person_phone" align="center"/>

                <a-table-column key="ope" title="操作" fixed="right" align="center" :width="80">
                    <template slot-scope="record">
                        <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()"><a-icon type="ellipsis" /></a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a class="fs12" @click="checkDetail(record)">查看</a>
                                </a-menu-item>
                                <a-menu-item v-if="record.create_uid == personDetail.uid" >
                                    <a class="fs12" @click="edit(record)">编辑</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a-popconfirm
                                        title="是否删除?"
                                        ok-text="是"
                                        cancel-text="否"
                                        @confirm="deleteUser(record.id)"
                                    >
                                        <a style="color: #fd6364;" class="fs12">删除</a>
                                    </a-popconfirm>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
                </a-table-column>
            </a-table>

            <a-drawer
                :width="1200"
                :visible="detailVisible"
                :body-style="{ paddingBottom: '80px' }"
                @close="detailVisible=false"
                :closable="false"

                placement="right"
                :maskStyle="{background: 'rgba(0,0,0,0)'}"
                :wrapStyle="{marginTop: '50px', height: 'calc(100% - 50px)'}"
                :bodyStyle="{padding: 0, height: '100%', position: 'relative'}"
                :drawerStyle="{overflow: 'visible'}"
                width="calc(100% - 270px)"
            >
                <div v-if="detailVisible" @click="detailVisible=false" class="flex items-center content-center bg-white cursor-pointer" style="position: absolute; width: 30px; height: 30px; top: 0; left: -30px; box-shadow: 5px 5px 5px rgba(0,0,0,0.05);">
                    <a-icon type="close" :style="{color: '#f94140'}" />
                </div>
                <div class="scroll h100" style="background-color: #f3f6fa;">
                    <!-- <CardCaseListDetail ref="son" :purchase="select_purchase" :approvalDetail="approvalDetail" :approvalForm="approval_form"  @update-param="updateParam"></CardCaseListDetail> -->
                    <CardLetterListDetail ref="son" :form="form"></CardLetterListDetail>
                </div>
            </a-drawer>

            <!-- <a-modal v-model="detailVisible" title="律师函详情" width="60%" :centered="true" :footer="null">
                <CardLetterListDetail :form="form"></CardLetterListDetail>
            </a-modal> -->
            <a-modal v-model="addVisible" title="添加律师函" @ok="save" width="60%" :centered="true" okText="保存" cancelText="取消">
                <div class="flex">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">项目</div>
                            <a-select v-model="form.project_id" show-search option-filter-prop="children" :filter-option="filterOption" class="flex-width" size="small">
                                <a-select-option
                                    v-for="item in projects"
                                    :key="item.id"
                                    :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="flex-width ml30"></div>
                </div>
                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">发函时间</div>
                            <a-date-picker :valueFormat="dateFormat" :format="dateFormat" v-model="form.release_time" :locale="locale" size="small" class="flex-width" ></a-date-picker>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex items-center">
                            <div style="width: 100px;">收件日期</div>
                            <a-date-picker :valueFormat="dateFormat" :format="dateFormat" v-model="form.receive_time" :locale="locale" size="small" class="flex-width" ></a-date-picker>
                        </div>
                    </div>
                </div>
                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">我方单位</div>
                            <a-input v-model="form.company_entity" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex items-center">
                            <div style="width: 100px;">核对金额</div>
                            <div><a-input-number style="width: 200px"  size="small" v-model="form.check_amount" :min="0" :step="0.01" :precision="2" placeholder="请输入金额"></a-input-number></div>
                            <!-- <a-input v-model="form.check_amount" size="small" class="flex-width"></a-input> -->
                        </div>
                    </div>
                </div>
                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">发函单位</div>
                            <a-input v-model="form.release_entity" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex items-center">
                            <div style="width: 100px;">单位属性</div>
                            <a-input v-model="form.entity_prop" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                </div>

                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">委托律所</div>
                            <a-input v-model="form.law_firm_name" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex items-center">
                            <div style="width: 100px;">发函诉求</div>
                            <a-input v-model="form.appeal" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                </div>

                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">联系人</div>
                            <a-input v-model="form.contact_person" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex items-center">
                            <div style="width: 100px;">联系电话</div>
                            <a-input v-model="form.contact_person_phone" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                </div>

                <div class="flex mt15">
                    <div class="flex-width">
                        <div class="flex items-center">
                            <div style="width: 100px;">备注</div>
                            <a-input v-model="form.remark" size="small" class="flex-width"></a-input>
                        </div>
                    </div>
                    <div class="flex-width ml30">
                        <div class="flex" style="align-items: baseline;">
                            <div style="width: 100px;">
                                <a-upload multiple :action="upload_url" :headers="headers" @change="handleChangeAttachments" :showUploadList="false">
                                    <a-button size="small"> <a-icon type="upload" /> 上传材料 </a-button>
                                </a-upload>
                            </div>
                            <div class="mt5" v-if="form.attachmentData != null && form.attachmentData.length > 0">
                                <div class="flex items-center m-attachment" v-for="(item, i) in form.attachmentData" :key="i">
                                    <a-icon type="paper-clip" />
                                    <a class="one-line" style="text-decoration:none;" @click="preview(item)">
                                        <span>{{item.name}}</span>
                                    </a>
                                    <a-icon type="close" class="m-close" @click="removeAttachment(i)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </a-modal>
        </div>
        <div class="flex-reverse mt10">
            <a-pagination
                v-model="pagination.page"
                :page-size-options="pageSizeOptions"
                :total="pagination.total"
                show-size-changer
                :page-size="pagination.len"
                size="small"
                @showSizeChange="onShowSizeChange"
                @change="onShowSizeChange"
            >
                <template slot="buildOptionText" slot-scope="props">
                    <span>{{ props.value }}条/页</span>
                </template>
            </a-pagination>
        </div>
        <a-modal title="预览" v-model="image_visible" @ok="downImg(preview_url)" okText="下载到本地" cancelText="返回" @cancel="image_visible = false">
            <div class="w100 h100">
                <img :src="preview_url" alt="" width="100%" height="100%" style="object-fit: contain;" :data-original="preview_url">
            </div>
        </a-modal>
        <a-modal
            :title="previewDoc.title"
            :visible="docVisible"
            width="100%"
            centered
            @cancel="docVisible=false"
            :footer="null"
            >
            <div v-if="previewDoc.isPdf">
                <pdf :src="previewDoc.url" v-for="item in numPages"
                    :key="item"
                    :page="item"
                ></pdf>
            </div>
            <div v-else>
                <VueDocPreview :value="previewDoc.url" :type="previewDoc.docType" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import $ from "jquery";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import CardLetterListDetail from '../../components/Cards/CardLetterListDetail.vue';

export default {
    components:{
        CardLetterListDetail
    },
    data() {
        return {
            locale,
            tableHeight: 100,
            addVisible: false,
            detailVisible:false,
            columns: [],
            data: [],
            projects: [],
            dateFormat: "YYYY-MM-DD",
            loading: false,
            form: {
                id: null,
                release_time: null,
                receive_time: null,
                company_entity: null,
                check_amount: null,
                release_entity: null,
                entity_prop: null,
                law_firm_name: null,
                appeal: null,
                contact_person: null,
                contact_person_phone: null,
                remark:null,
                attachmentData:[],

            },
            searchForm: {
                text: null
            },
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            pagination: {
                total: 10,
                page: 1,
                len: 10
            },
            upload_url:"",
            headers:{},
            image_visible:false,
            docVisible:false,
            preview_url:"",
            previewDoc: {
                title: "",
                isPdf: false
            },
            personDetail:{uid:null, }

        }
    },
    created() {
        this.getProjectList();
        this.getLawLetter();
        this.upload_url = this.$api.request_body.url + "/project/upload_assets";
		this.headers.token = this.$api.request_body.token;
        setTimeout(() => {
            this.tableHeight = $("#dataview").height() - 60;
        }, 100);
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async getProjectList() {
            let rs = await this.$api.getProjectList();
            if (rs.err == 0) {
                rs.data.unshift({
                    id: 0, name: "全部项目"
                })
                this.projects = rs.data;
            }
        },
        onShowSizeChange(current, pageSize) {
            this.pagination.len = pageSize;
            this.getLawLetter();
        },
        showAdd() {
            this.form.id = null;
            this.form.release_time = null;
            this.form.receive_time = null;
            this.form.company_entity = null;
            this.form.check_amount = null;
            this.form.release_entity = null;
            this.form.entity_prop = null;
            this.form.law_firm_name = null;
            this.form.appeal = null;
            this.form.contact_person = null;
            this.form.contact_person_phone = null;

            this.addVisible = true;
        },
        checkDetail(record) {
            this.form = record;
            this.detailVisible = true;
        },
        edit(record) {
            this.form = record;
            this.addVisible = true;
        },
        async getLawLetter() {
            this.loading = true;
            let rs = await this.$api.getLawLetter(this.searchForm.project_id, this.searchForm.text, this.pagination.page - 1, this.pagination.len);
            this.loading = false;
            if (rs.err == 0) {
                let list = rs.data.first;
                let ca = 1
                for (let item of list) {
                    // item.key = item.id;
                    item.key = ca
                    item.attachmentData = JSON.parse(item.attachments)
                    let s = item.create_time;
                    item.create_time = new Date(s[0], s[1]-1, s[2], s[3], s[4], s[5]).Format("yyyy-MM-dd hh:mm:ss");//`${s[0]}-${s[1]}-${s[2]} ${s[3]}:${s[4]}:${s[5]}`
                    // item.create_time = item.create_time.replace('T', ' ')
                    if(item.modify_time!=null){
                        let d = item.modify_time;
                        item.modify_time = new Date(d[0], d[1]-1, d[2], d[3], d[4], d[5]).Format("yyyy-MM-dd hh:mm:ss");//`${s[0]}-${s[1]}-${s[2]} ${s[3]}:${s[4]}:${s[5]}`
                    }
                    ca++;
                }
                this.data = list;
                this.pagination.total = rs.data.second;
                this.personDetail.uid = rs.uid
            }
        },
        check(){
            if(this.form.project_id == null){
                this.$message.error("请选择项目")
                return false
            }
            if(this.form.release_time == null){
                this.$message.error("请选择发函时间")
                return false
            }
            return true;
        },
        async save() {
            if(!this.check()){
                return;
            }

            this.form.attachments = JSON.stringify(this.form.attachmentData)
            let rs = await this.$api.saveLawLetter(this.form);
            if (rs.err == 0) {
                this.$message.success("保存成功");
                this.addVisible = false;
                this.getLawLetter();
            }
        },
        async deleteUser(id) {
            let rs = await this.$api.deleteLawLetter(id);
            if (rs.err == 0) {
                this.$message.success("删除成功");
                this.getLawLetter();
            }
        },
        handleChangeAttachments(info) {
            const status = info.file.status;
            if (status === 'uploading') {
                return;
            }
            if (status === 'done') {
                if (info.file.response.err == 0) {
                    // this.addProsecuteDoc(info.file)
                    // this.prosecuteFileList.push({name:info.file.name, url:info.file.response.data})
                    this.form.attachmentData.push({name:info.file.name, url:info.file.response.data})
                    this.$message.success(`${info.file.name} 上传成功`);
                } else {
                    this.$message.error(`${info.file.name} 上传失败`);
                }
            } else if (status === 'error') {
                this.$message.error(`${info.file.name} 上传失败.`);
            }
            this.$forceUpdate();
        }, 
        preview(item){
            this.previewDoc.title = item.name;
            this.previewDoc.url = item.url;
            this.preview_url = item.url;
            let suffix = this.previewDoc.title.substring(this.previewDoc.title.lastIndexOf(".") + 1)
            if(suffix == "jpg" || suffix == "png"){
                this.image_visible = true
            }else if(suffix == "rar" || suffix == "zip"){
                this.$message.error("该文件为压缩包文件，不支持预览，请下载后解压查看")
            }else{
                if (suffix == "pdf") {
                    const link = document.createElement('a');
                    link.href = item.url;
                    link.download = item.name; // 设置下载的文件名，根据实际需要修改
                    link.target = '_blank'; // 在新窗口打开下载链接
                    link.click(); // 模拟点击触发下载
                }else if(suffix == "docx" || suffix == "xlsx" || suffix == "pptx"){
                    this.previewDoc.url = "https://api.hidocs.cn/api?furl=" + this.previewDoc.url;
                    window.open(this.previewDoc.url)
                }else{
                    this.previewDoc.url = "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(this.previewDoc.url);
                    window.open(this.previewDoc.url)
                    this.previewDoc.isPdf = false;
                    this.previewDoc.docType = "office";
                    // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(item.url));

                    // this.docVisible = true;
                }
            }
        },
        removeAttachment(i) {
            if (this.form.attachmentData.length != 0) {
                this.form.attachmentData.splice(i, 1);
                this.$forceUpdate();
            }
        },
        // downImg(item){
        //     const link = document.createElement('a');
        //     link.href = item;
        //     link.download = 'image.jpg'; // 设置下载的文件名，根据实际需要修改
        //     link.target = '_blank'; // 在新窗口打开下载链接
        //     link.click(); // 模拟点击触发下载
        // },
        downImg(src){
            this.getBlob(this.preview_url, (blob) => {
                this.saveAs(blob, this.previewDoc.title)
            })
        
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
                if (xhr.status === 200) {
                cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.flow-item {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
    padding: 5px 5px 5px 5px;
    font-size: 12px;
}
.select-flow-item {
    cursor: pointer;
    position: relative;
    .item {
        border-bottom: 1px solid rgba(0,0,0,0.1);
        padding: 5px 5px 5px 5px;
        font-size: 12px;
    }
}
.select-flow-item:not(:last-child):after {
    content: "";
    position: absolute;
    right: -10px;
    top: 23px;
    height: 2px;
    width: 10px;
    background: #d8d8d8;
}
.user_group {
    list-style-type: none;
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;

    li {
        height: 30px;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;

        &.active {
            background: #67C23A;
            color: white;
        }
    }
}
</style>

<style scoped>
/deep/.ant-table {
    font-size: 13px!important;
}
/* 调整表格的样式以显示滚动条在标题栏下方 */  
/deep/.ant-table-thead > tr > th {
    font-size: 14px!important;
}


</style>

<style lang="scss" scoped>
.m-attachment {
    padding: 5px;
    transition: all 0.3s;
    .m-close {
        opacity: 0;
        transition: all 0.3s;
    }
}
.m-attachment:hover {
    background-color: #f5f5f5;
    transition: all 0.3s;
    .m-close {
        opacity: 1;
        transition: all 0.3s;
    }
}
// .customer-checkbox .ant-checkbox-group-item {
//     width: 100%;
// }
</style>

<style scoped>
/deep/.ant-table-thead {
    background: #f0f2f5;
}

/deep/.ant-drawer-content {
    overflow: visible;
}
/deep/.ant-form-item {
    margin-bottom: 13px!important;
}
/deep/.ant-table {
    font-size: 13px!important;
}

</style>